/* Bisou Tea home page behaviour (port of the Home.dc.html component logic to vanilla JS).
   Sections mark themselves with [data-bt-home="<kind>"]; each is initialised once and again after shopify:section:load.
   kinds: hero, row, sachet, details, ritual, locator. */
(function () {
  if (window.BTHome) { window.BTHome.init(); return; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---- hero: word-by-word headline, card and background settle (the mockup flips `loaded` after 80ms) */
  function hero(el) {
    setTimeout(function () { requestAnimationFrame(function () { el.classList.add('is-ready'); }); }, 80);
  }

  /* ---- most loved row: prev/next, progress bar */
  function row(el) {
    var scroller = $('[data-row]', el), bar = $('[data-row-bar]', el);
    if (!scroller || !bar) return;
    function upd() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      var p = max > 0 ? scroller.scrollLeft / max : 0;
      var v = scroller.scrollWidth ? scroller.clientWidth / scroller.scrollWidth : 1;
      var w = Math.max(8, Math.min(100, v * 100));
      bar.style.width = w + '%';
      bar.style.marginLeft = (p * (100 - w)) + '%';
    }
    function by(d) { scroller.scrollBy({ left: d * scroller.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' }); }
    var prev = $('[data-row-prev]', el), next = $('[data-row-next]', el);
    if (prev) prev.addEventListener('click', function () { by(-1); });
    if (next) next.addEventListener('click', function () { by(1); });
    scroller.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    setTimeout(upd, 300); upd();
  }

  /* ---- the "0% plastic" counter and line-drawn sachet */
  function sachet(el) {
    var z = $('[data-zero]', el);
    if (!z || reduce) return;
    var from = parseFloat(z.getAttribute('data-from')), to = parseFloat(z.getAttribute('data-to'));
    var D = parseFloat(z.getAttribute('data-duration')) || 2800;
    if (isNaN(from)) from = 100;
    if (isNaN(to)) to = 0;
    var val = $('[data-zero-val]', z), paths = $$('[data-bag]', z), TH = [0.45, 0.55, 0.62, 0.68, 0.75];
    function paint(k) {
      var ze = 1 - Math.pow(1 - k, 3);
      if (val) val.textContent = Math.round(from + (to - from) * ze);
      paths.forEach(function (p, i) {
        var d = Math.max(0, Math.min(1, 1 - (k - TH[i]) / 0.25));
        p.setAttribute('stroke-dashoffset', d);
      });
    }
    paint(0);
    var started = false;
    function check() {
      if (started) return;
      if (z.getBoundingClientRect().top < window.innerHeight * 0.75) {
        started = true; window.removeEventListener('scroll', check);
        var t0 = performance.now();
        (function tick(t) { var k = Math.min(1, (t - t0) / D); paint(k); if (k < 1) requestAnimationFrame(tick); })(t0);
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    setTimeout(check, 300);
  }

  /* ---- thoughtful in every detail: hover or tap to switch, images crossfade */
  function details(el) {
    var items = $$('[data-detail]', el);
    if (!items.length) return;
    var imgs = $$('[data-detail-img]', el), icons = $$('[data-detail-icon]', el);
    var eb = $('[data-detail-eyebrow]', el), st = $('[data-detail-stat]', el);
    function set(i) {
      items.forEach(function (b, n) { b.classList.toggle('is-active', n === i); b.setAttribute('aria-expanded', n === i ? 'true' : 'false'); });
      imgs.forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
      icons.forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
      if (eb) eb.textContent = items[i].getAttribute('data-eyebrow') || '';
      if (st) st.textContent = items[i].getAttribute('data-stat') || '';
    }
    items.forEach(function (b, i) {
      b.addEventListener('click', function () { set(i); });
      b.addEventListener('mouseenter', function () { set(i); });
      b.addEventListener('focus', function () { set(i); });
    });
    el.__btSet = set;
  }

  /* ---- find your ritual: tag switcher with fade */
  function ritual(el) {
    var tags = $$('[data-rit]', el);
    if (!tags.length) return;
    var detail = $('.bt-home-rit__detail', el), stage = $('[data-rit-stage]', el), figs = $$('[data-rit-img]', el);
    var nEl = $('[data-rit-notes]', el), nameEl = $('[data-rit-name]', el), lineEl = $('[data-rit-line]', el), link = $('[data-rit-link]', el);
    var cur = 0, timer;
    function apply(i) {
      var t = tags[i];
      cur = i;
      tags.forEach(function (b, n) { b.classList.toggle('is-selected', n === i); b.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
      if (nEl) nEl.textContent = t.getAttribute('data-notes') || '';
      if (nameEl) nameEl.textContent = t.getAttribute('data-name') || '';
      if (lineEl) lineEl.textContent = t.getAttribute('data-line') || '';
      var u = t.getAttribute('data-url');
      if (link) { if (u) link.setAttribute('href', u); var l = t.getAttribute('data-btn'); if (l) link.textContent = l; }
      if (stage) stage.style.backgroundColor = t.getAttribute('data-accent') || '';
      figs.forEach(function (f) { f.classList.toggle('is-active', +f.getAttribute('data-rit-img') === i); });
      if (detail) detail.classList.remove('is-fading');
    }
    function pick(i) {
      if (i === cur) return;
      clearTimeout(timer);
      if (detail) detail.classList.add('is-fading');
      figs.forEach(function (f) { f.classList.remove('is-active'); });
      timer = setTimeout(function () { apply(i); }, reduce ? 0 : 280);
    }
    tags.forEach(function (b, i) { b.addEventListener('click', function () { pick(i); }); });
    el.__btSet = function (i) { clearTimeout(timer); apply(i); };
  }

  /* ---- store locator teaser: region tags + search + Leaflet map built inline.
     Two pin sources: the section's Stockist blocks (default), or, with data-meta="1", every row of the shop
     metafield store_locator.stores (small gold dots). In metafield mode the left column shows the curated blocks
     until a search query or a region is active; then it shows the matching metafield stores (Stockists row style,
     first 6, count, "see all" link) and the map follows. Region tags are built from the data. */
  var PROV = { 'alberta': 'AB', 'british columbia': 'BC', 'manitoba': 'MB', 'new brunswick': 'NB', 'newfoundland and labrador': 'NL', 'nova scotia': 'NS', 'northwest territories': 'NT', 'nunavut': 'NU', 'ontario': 'ON', 'prince edward island': 'PE', 'quebec': 'QC', 'québec': 'QC', 'saskatchewan': 'SK', 'yukon': 'YT' };
  var PROVC = { AB: 'Alberta', BC: 'British Columbia', MB: 'Manitoba', NB: 'New Brunswick', NL: 'Newfoundland and Labrador', NS: 'Nova Scotia', NT: 'Northwest Territories', NU: 'Nunavut', ON: 'Ontario', PE: 'Prince Edward Island', QC: 'Quebec', SK: 'Saskatchewan', YT: 'Yukon' };
  function str(v) { return v == null ? '' : String(v).trim(); }
  function regionCode(name) {
    var n = str(name);
    return PROV[n.toLowerCase()] || n.toUpperCase();
  }
  /* region as the Stockists page names it: full province name for Canada, the raw code otherwise */
  function regionName(code, country) {
    var c = str(code).toUpperCase();
    return (str(country) === 'CA' && PROVC[c]) ? PROVC[c] : c;
  }
  function metaPins(raw) {
    var out = [];
    (Array.isArray(raw) ? raw : []).forEach(function (x) {
      if (!x) return;
      var lat = parseFloat(x.lat), lng = parseFloat(x.lng);
      if (!isFinite(lat) || !isFinite(lng) || (!lat && !lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180) return;
      var n = str(x.n); if (!n) return;
      var city = str(x.c), rg = str(x.r).toUpperCase(), addr = str(x.a), web = str(x.w);
      var w = city ? [city, rg].filter(Boolean).join(', ') : (addr || rg);
      if (web && !/^https?:\/\//i.test(web)) web = 'https://' + web;
      var rn = regionName(rg, x.k);
      out.push({ n: n, w: w, r: rg, rn: rn, url: web, c: [lat, lng],
        hay: [n, w, city || addr, rn, rg, str(x.p)].join(' ').toLowerCase() });
    });
    return out;
  }

  function locator(el) {
    var mapEl = $('[data-loc-map]', el), dataEl = $('[data-loc-data]', el), list = $('[data-loc-list]', el);
    var metaEl = $('[data-loc-meta]', el);
    var tagsEl = $('[data-loc-tags]', el), qInput = $('[data-loc-q]', el), btnWrap = $('[data-loc-btn]', el);
    var resEl = $('[data-loc-results]', el), rlist = $('[data-loc-rlist]', el), countEl = $('[data-loc-count]', el), emptyEl = $('[data-loc-empty]', el);
    var tags = $$('[data-loc-region]', el), stores = $$('[data-loc-store]', el);
    var S = [], M = [], markers = [], map = null, region = 'All', busy, hl = null;
    try { S = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { S = []; }
    if (el.getAttribute('data-meta') === '1' && metaEl) {
      try { M = metaPins(JSON.parse(metaEl.textContent)); } catch (e) { M = []; }
    }
    var all = M.length > 0;           /* metafield mode; an empty metafield falls back to the block pins */
    var P = all ? M : S;
    var lAll = el.getAttribute('data-l-all') || 'All';
    var lOne = el.getAttribute('data-l-one') || 'stockist', lMany = el.getAttribute('data-l-many') || 'stockists';
    var lKind = el.getAttribute('data-l-kind') || '', lCta = el.getAttribute('data-l-cta') || '';
    var pageSize = parseInt(el.getAttribute('data-page-size'), 10) || 6;
    var newTab = el.getAttribute('data-new-tab') !== 'false';
    var st = { q: '', region: '' };   /* metafield mode state; region '' = All, else a region name */
    var timer = null, pendingSync = false;

    function popEl(s) {
      var pop = document.createElement('div'); pop.className = 'bt-home-pop';
      var b = document.createElement('b'); b.textContent = s.n;
      var sp = document.createElement('span'); sp.textContent = s.w;
      pop.appendChild(b); pop.appendChild(sp);
      return pop;
    }
    function inRegion(s, rg) {
      if (!rg || rg === 'All' || rg === 'Online') return true;
      return s.r === rg;
    }
    function flyTo(pts) {
      if (pts.length === 1) map.flyTo(pts[0], 11, { duration: reduce ? 0 : 1.2 });
      else map.flyToBounds(pts, { padding: [48, 48], duration: reduce ? 0 : 1.2, maxZoom: 9 });
    }
    function fit(pts) {
      if (pts.length === 1) map.setView(pts[0], 11);
      else map.fitBounds(pts, { padding: [48, 48], maxZoom: active() ? 9 : undefined });
    }
    function dropHl() { if (hl && map) map.removeLayer(hl); hl = null; }

    /* metafield mode: show only the pins at the given indexes; pins already on the map keep their place, new ones drop in */
    function showSet(vis) {
      var keep = {};
      vis.forEach(function (i) { keep[i] = true; });
      var fresh = vis.filter(function (i) { return !map.hasLayer(markers[i]); });
      var step = Math.min(140, 1000 / Math.max(1, fresh.length)), n = 0;
      markers.forEach(function (m, i) { if (!keep[i] && map.hasLayer(m)) map.removeLayer(m); });
      fresh.forEach(function (i) {
        var m = markers[i].addTo(map), e = m.getElement(), dot = e && e.firstChild && e.firstChild.firstChild;
        if (dot) dot.style.animationDelay = (200 + n * step) + 'ms';
        n++;
      });
      return vis.map(function (i) { return P[i].c; });
    }
    function highlight(b) {
      dropHl();
      var icon = window.L.divIcon({ className: '', html: '<div class="bt-home-pin on"><i style="animation-delay:0ms"></i></div>', iconSize: [30, 30], iconAnchor: [15, 15] });
      hl = window.L.marker(b.c, { icon: icon, zIndexOffset: 1000, keyboard: false }).addTo(map).bindPopup(popEl(b));
      map.flyTo(b.c, 11, { duration: reduce ? 0 : 1.2 });
      hl.openPopup();
    }

    /* ---- metafield mode: search + region state, results list, map sync */
    function active() { return !!(st.q || st.region); }
    function matches() {
      var q = st.q.toLowerCase(), out = [];
      M.forEach(function (s, i) {
        if (st.region && s.rn.toLowerCase() !== st.region.toLowerCase()) return;
        if (q && s.hay.indexOf(q) === -1) return;
        out.push(i);
      });
      return out;
    }
    function allIdx() { return M.map(function (s, i) { return i; }); }
    function syncMap(idx, animate) {
      if (!map) { pendingSync = true; return; }
      dropHl(); map.closePopup();
      var pts = showSet(idx.length ? idx : allIdx());
      if (!idx.length) return;
      if (animate) flyTo(pts);
      else fit(pts);
    }
    function mk(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
    function goRow(i) {
      if (!map) return;
      highlight(M[i]);
      if (window.innerWidth < 900) {
        var r = mapEl.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) mapEl.parentNode.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }
    }
    function drawResults(idx) {
      var on = active();
      if (list) list.hidden = on;
      if (btnWrap) btnWrap.hidden = on;
      if (resEl) resEl.hidden = !on;
      if (!on || !rlist) return;
      countEl.textContent = idx.length + ' ' + (idx.length === 1 ? lOne : lMany);
      rlist.textContent = '';
      idx.slice(0, pageSize).forEach(function (i, n) {
        var s = M[i];
        var row = mk('article', 'bt-stk-row');
        row.style.transitionDelay = (n * 60) + 'ms';
        row.tabIndex = 0; row.setAttribute('aria-label', s.n + (s.w ? ', ' + s.w : ''));
        var text = mk('div', 'bt-stk-row__text');
        text.appendChild(mk('span', 'bt-stk-row__name', s.n));
        if (s.w) text.appendChild(mk('span', 'bt-stk-row__where', s.w));
        row.appendChild(text);
        var side = mk('div', 'bt-stk-row__side');
        if (lKind) side.appendChild(mk('span', 'bt-badge', lKind));
        if (lCta && s.url) {
          var a = mk('a', 'bt-stk-row__link bt-hover-gold', lCta + ' →');
          a.href = s.url;
          if (newTab) { a.target = '_blank'; a.rel = 'noopener'; }
          a.addEventListener('click', function (e) { e.stopPropagation(); });
          side.appendChild(a);
        }
        if (side.firstChild) row.appendChild(side);
        row.addEventListener('click', function () { goRow(i); });
        row.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === row) { e.preventDefault(); goRow(i); } });
        rlist.appendChild(row);
      });
      if (emptyEl) emptyEl.hidden = idx.length !== 0;
    }
    function applyMeta() {
      var idx = matches();
      drawResults(idx);
      if (list) list.classList.remove('is-hiding');
      if (rlist) setTimeout(function () { rlist.classList.add('is-shown'); }, 30);
      syncMap(idx, true);
    }
    function changeMeta() {
      clearTimeout(timer);
      if (list) list.classList.add('is-hiding');
      if (rlist) rlist.classList.remove('is-shown');
      timer = setTimeout(applyMeta, reduce ? 0 : 200);
    }
    function drawTags() {
      if (!tagsEl) return;
      tagsEl.textContent = '';
      var items = [{ label: lAll, value: '' }];
      var override = str(el.getAttribute('data-regions'));
      if (override) {
        override.split(',').forEach(function (t) {
          t = str(t);
          if (!t || t.toLowerCase() === 'all' || t.toLowerCase() === lAll.toLowerCase()) return;
          var v = PROV[t.toLowerCase()] ? PROVC[PROV[t.toLowerCase()]] : (PROVC[t.toUpperCase()] || t.toUpperCase());
          items.push({ label: t, value: v });
        });
      } else {
        var counts = {}, order = [];
        M.forEach(function (s) { if (!s.rn) return; if (!(s.rn in counts)) { counts[s.rn] = 0; order.push(s.rn); } counts[s.rn]++; });
        order.sort(function (a, b) { return counts[b] - counts[a] || a.localeCompare(b); });
        order.forEach(function (r) { items.push({ label: r, value: r }); });
      }
      items.forEach(function (it) {
        var on = it.value.toLowerCase() === st.region.toLowerCase();
        var b = mk('button', 'bt-tag' + (on ? ' is-selected' : ''), it.label);
        b.type = 'button'; b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.addEventListener('click', function () {
          if (st.region.toLowerCase() === it.value.toLowerCase()) return;
          st.region = it.value; drawTags(); changeMeta();
        });
        tagsEl.appendChild(b);
      });
    }

    /* ---- block mode (and curated row clicks): focus a region, or one Stockist block */
    function focus(rg, name) {
      if (!map || !P.length) return;
      if (all) {
        if (name) {
          var b = S.filter(function (s) { return s.n === name; })[0];
          if (b) highlight(b);
        }
        return;
      }
      var pts = S.filter(function (s) {
        return (!rg || rg === 'All' || rg === 'Online' || s.r === rg) && (!name || s.n === name);
      }).map(function (s) { return s.c; });
      if (!pts.length) pts = S.map(function (s) { return s.c; });
      flyTo(pts);
      S.forEach(function (s, i) {
        var m = markers[i], e = m && m.getElement();
        if (e && e.firstChild) e.firstChild.classList.toggle('on', !!name && s.n === name);
        if (name && s.n === name && m) m.openPopup();
      });
    }

    function build() {
      if (map || !window.L || !mapEl) return;
      var L = window.L;
      map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: true, attributionControl: true });
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '&copy; OpenStreetMap contributors' }).addTo(map);
      map.on('zoomend moveend', function () { /* pins grow from the country view up (province level ~1.5x, dots ~2x) so they stay visible on the busier tiles */ var z = map.getZoom(), d = Math.max(0, z - 3); mapEl.style.setProperty('--bt-pin-s', String(Math.min(1.75, 1 + d * 0.15).toFixed(2))); mapEl.style.setProperty('--bt-dot-s', String(Math.min(2.4, 1 + d * 0.3).toFixed(2))); });
      if ('ResizeObserver' in window) new ResizeObserver(function () { map.invalidateSize(); }).observe(mapEl);
      if (all) {
        markers = M.map(function (s) {
          var icon = L.divIcon({ className: '', html: '<div class="bt-home-pin dot"><i></i></div>', iconSize: [14, 14], iconAnchor: [7, 7] });
          return L.marker(s.c, { icon: icon, keyboard: false }).bindPopup(function () { return popEl(s); });
        });
        var idx = matches();
        var pts = showSet(idx.length ? idx : allIdx());
        fit(pts);
        pendingSync = false;
        return;
      }
      markers = S.map(function (s, i) {
        var icon = L.divIcon({ className: '', html: '<div class="bt-home-pin"><i style="animation-delay:' + (300 + i * 140) + 'ms"></i></div>', iconSize: [30, 30], iconAnchor: [15, 15] });
        return L.marker(s.c, { icon: icon }).addTo(map).bindPopup(popEl(s));
      });
      if (S.length) map.fitBounds(S.map(function (s) { return s.c; }), { padding: [48, 48] });
      else map.setView([56, -96], 3);
    }
    function whenLeaflet() {
      if (window.L) { build(); return; }
      var tries = 0, iv = setInterval(function () { if (window.L) { clearInterval(iv); build(); } else if (++tries > 100) clearInterval(iv); }, 100);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); whenLeaflet(); } }, { rootMargin: '300px 0px' });
      io.observe(el);
    } else whenLeaflet();

    if (all) {
      drawTags();
      if (qInput) {
        qInput.addEventListener('input', function () { st.q = qInput.value.trim(); changeMeta(); });
        var f = qInput.closest('form'); if (f) f.addEventListener('submit', function (e) { e.preventDefault(); });
      }
    } else {
      if (qInput && qInput.closest('.bt-field')) qInput.closest('.bt-field').hidden = true;
      var setRegion = function (r) {
        if (r === region) return;
        focus(r);
        if (list) list.classList.add('is-hiding');
        clearTimeout(busy);
        busy = setTimeout(function () {
          region = r;
          tags.forEach(function (t) { var on = t.getAttribute('data-loc-region') === r; t.classList.toggle('is-selected', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          var n = 0;
          stores.forEach(function (s) {
            var show = r === 'All' || s.getAttribute('data-region') === r;
            s.hidden = !show;
            if (show) { s.style.transitionDelay = (n * 60) + 'ms'; n++; }
          });
          if (list) list.classList.remove('is-hiding');
        }, reduce ? 0 : 200);
      };
      tags.forEach(function (t) { t.addEventListener('click', function () { setRegion(t.getAttribute('data-loc-region')); }); });
    }
    stores.forEach(function (s) { s.addEventListener('click', function () { focus(null, s.getAttribute('data-loc-store')); }); });
  }

  var kinds = { hero: hero, row: row, sachet: sachet, details: details, ritual: ritual, locator: locator };
  function init(scope) {
    $$('[data-bt-home]', scope || document).forEach(function (el) {
      if (el.__btHome) return;
      el.__btHome = true;
      var f = kinds[el.getAttribute('data-bt-home')];
      if (f) f(el);
    });
  }
  window.BTHome = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target, sec = b.closest && b.closest('[data-bt-home]');
    if (!sec || !sec.__btSet) return;
    var i = b.getAttribute('data-detail') || b.getAttribute('data-detail-img') || b.getAttribute('data-detail-icon') || b.getAttribute('data-rit') || b.getAttribute('data-rit-img');
    if (i !== null) sec.__btSet(parseInt(i, 10));
  });
})();
